// removed by extract-text-webpack-plugin
module.exports = {"intro":"EyewR8PUIR9AKtZUJgIHx","sub-title":"_3LofH9iFotQ7Wrdm5MTkYx","subTitle":"_3LofH9iFotQ7Wrdm5MTkYx","title":"_3chbdKsUl0BthAbi1Pr0y3","wrapper":"_1vIKu7WAtb62hXeSeDXoQO"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Header/Content/styles.scss
 ** module id = 420
 ** module chunks = 0
 **/